// extracted by mini-css-extract-plugin
export var content = "portfolio-layout-module--content--98f19";
export var image = "portfolio-layout-module--image--ada7e";
export var link = "portfolio-layout-module--link--fcaec";
export var portfolio = "portfolio-layout-module--portfolio--6ea44";